import React from "react";
import { useBreakpoint } from "../../hooks/useBreakpoint";

import InternshipVideoCard from "../../components/cards/internshipVideoCard";

const TestimonialVideoGallery = ({
  pageTestimonials,
  genFeaturedGalleryTitle,
  containerClass,
  galleryTitleClass = "pb-10 md:pb-16",
  innerContainerClass = ""
}) => {
  const breakpoint = useBreakpoint();

  if (!pageTestimonials || pageTestimonials?.length < 1) {
    return <></>;
  }

  return (
    <section
      className={`past-interns-section relative w-full ${containerClass}`}
    >
      <div
        className={`w-11/12 md:w-9/12 mx-auto py-20 pt-10 md:pt-20 ${innerContainerClass}`}
      >
        {genFeaturedGalleryTitle && (
          <h1
            className={`title font-normal dark:font-light ${galleryTitleClass}`}
            dangerouslySetInnerHTML={{ __html: genFeaturedGalleryTitle }}
          />
        )}
        <div
          className={`flex flex-col md:flex-row w-full ${
            pageTestimonials?.length > 1 ? "h-108" : "h-auto"
          } md:h-auto pr-5 md:pr-0 overflow-y-auto md:overflow-visible gvi-scrollbar-thin`}
        >
          <div className="basis-full md:basis-2/3 pb-0 md:pr-5">
            {pageTestimonials?.slice(0, 1)?.map((testimonial, index) => {
              const description = testimonial?.genOverlayVideoTitle ?? "";
              const featVideo = testimonial.genVideoUrl ?? "";
              return (
                <InternshipVideoCard
                  key={index}
                  active={breakpoint !== "xs" && true}
                  title={`${description}`}
                  bgImage={""}
                  sourceUrl={""}
                  imgAlt={""}
                  featVideos={featVideo}
                  cardClass="rounded-xs bg-white dark:bg-gray-standard h-full w-[31%]"
                  type="quote"
                />
              );
            })}
          </div>
          <div className="relative basis-full md:basis-1/3">
            <div className="w-full md:absolute md:h-full md:overflow-y-auto md:pr-6 md:gvi-scrollbar-thin">
              {pageTestimonials?.slice(1, 10)?.map((testimonial, index) => {
                const name = testimonial?.genOverlayVideoTitle ?? "";
                const featVideo = testimonial.genVideoUrl ?? "";

                return (
                  <InternshipVideoCard
                    key={index}
                    active={false}
                    title={`${name?.substring(0, 80)}...`}
                    bgImage={""}
                    sourceUrl={""}
                    imgAlt={""}
                    featVideos={featVideo}
                    cardClass={"mt-20"}
                    type="quote"
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

TestimonialVideoGallery.defaultProps = {
  containerClass: "bg-yellow-lighter dark:bg-primary-bg overflow-hidden"
};

export default TestimonialVideoGallery;
